import { Stagger, StaggerItem } from "@/components/motion";
import { SectionHeading } from "@/components/primitives";
import Icon from "@/components/Icon";
import { PERSONAS } from "@/lib/site";

export default function BuiltFor() {
  return (
    <section id="built-for" className="relative border-t border-border py-24 sm:py-32" data-testid="built-for-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="Built For"
          title="Made for the people who run the whole thing."
          subtitle="From a team of one to a growing crew — Workspace adapts to how you operate."
        />

        <Stagger className="mt-16 grid gap-4 sm:mt-20 sm:grid-cols-2 lg:grid-cols-3">
          {PERSONAS.map((p) => (
            <StaggerItem key={p.title}>
              <div className="card-hover group flex h-full items-start gap-4 rounded-2xl border border-border bg-card p-6 hover:border-foreground/20">
                <div className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-muted/60 text-brand-teal transition-transform group-hover:scale-105">
                  <Icon name={p.icon} className="h-5 w-5" />
                </div>
                <div>
                  <h3 className="font-display text-lg font-semibold tracking-tight">{p.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{p.desc}</p>
                </div>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
